import { IEvent } from "@Interfaces";

export const getSelectedUpsellOfferingsData = ({
    upsellListings,
    selectedUpsellOfferingsQuantities,
}: {
    upsellListings: IEvent.IUpsellOffering[];
    selectedUpsellOfferingsQuantities: IEvent.ISelectedUpsellOfferingQuantities;
}) =>
    upsellListings.filter(
        i => i.additional_listing_uid in selectedUpsellOfferingsQuantities
    );
